<template>
  <div class='container'>
    <!-- <van-overlay :show="showShareType" class="grant-dialog">
      <div class="grant-wrap">
        <div class="title">用户授权</div>
        <div class="content">希望您允许授权以便记录您的务工信息</div>
        <div class="share-items">
          <van-button  type="info" size="normal" @click="toGrant">授 权</van-button>
        </div>
      </div>
    </van-overlay> -->
  </div>
</template> 

<script>
import { Dialog } from 'vant';
import { login } from '@/api/user'
import { mapMutations } from 'vuex'
import store from "@/store";
export default { 
  data() {
    return {
      appid: "wxbbfdbb21ee054b27",
      redirect_url: "",
      code: "",
      inviteUserId: "",
      isLock: false,
      btnIsShow: true,
      showShareType: true
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    this.inviteUserId = this.$route.query.inviteUserId?this.$route.query.inviteUserId:"";
    if(store.state.user.userId && store.state.user.loginToken) {
      this.showShareType = false;
      this.getSelfWorkDetail();
    } else { 
      // let propURL = window.location.href;
      // let status = this.GetParam(propURL,"status");
      // console.log(4444,this.redirect_url) 
      // if(propURL.indexOf("=") > -1 && !status) {
      //     this.redirect_url = window.location.protocol+"//"+window.location.host+ "/#/migrantFiles/migrantFilesGrant?inviteUserId=" + this.inviteUserId + "&status=redirect"
      //     this.showShareType = true;
      // } else if(status) {
      //     this.showShareType = false;
      //     this.btnIsShow = false;
      //     this.isLock = true;
      //     this.toWx();
      // }
       this.$router.push({
          path: "/migrantFiles/login",
          query: {
            inviteUserId: this.inviteUserId
          }
        })

    }
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    document.title = "授权"
  },
  methods:{
      ...mapMutations(['updateUser']),
      toGrant() {
          if(this.isLock) {
              return false;
          }
          this.toWx();
          this.isLock = true;
      },
      //拿到微信code 
      async toWx() {
        console.log(5643436,this.redirect_url)
        let url =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid="+ this.appid +"&redirect_uri=" +
          encodeURIComponent(this.redirect_url) +
          "&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect";
        
        this.code = await this.GetParam(window.location.href.split("#")[0], "code");
        
        if (!this.code) {
          location.href = url;
          this.isLock = false;

        } else {
          this.code = this.GetParam(window.location.href, "code");
          this.login();
        }

      },
      // 截取code
      GetParam(url, code) {
          url = url + "";
          let regstr = "/(\\?|\\&)" + code + "=([^\\&]+)/";
          let reg = eval(regstr);
          //eval可以将 regstr字符串转换为 正则表达式
          let result = url.match(reg);
          if (result && result[2]) {
            return result[2];
          }
      },
      async login() {
          try {
            let params = {
              platform: "center_h5",
              code: this.code
            };
            const result = await login(params);
            if(result.code == 200) {
              this.updateUser({ 
                token: result.data.loginToken,
                userId: result.data.userId
              })
              this.getSelfWorkDetail(); 
              
            } else {
                Dialog({ message: result.message });
                this.isLock = false;
            }
          } catch (error) {
            this.$gnotify({ message: '登录失败' })
          }
      },
      getSelfWorkDetail() {
        this.$router.push({
          path: "/migrantFiles/myJobInfo",
          query: {
            inviteUserId: this.inviteUserId
          }
        })
      },
  },
};
</script>
<style scoped lang="less">
/* @import url(); 引入css类 */
.container{
  .grant-dialog {
    display: flex;
    justify-content: center;
    align-items: center;
    .grant-wrap {
      width: 80%;
      padding: 20px;
      background: #fff;
      border-radius: 10px;
      .title {
        font-size: 20px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 20px;
      }
      .content {
        text-align: center;
        color: #000;
        font-size: 17px;
        margin-bottom: 40px;
      }
      .share-items {
        text-align: center;
        margin-top: 20px;
        button {
          font-size: 17px;
          width: 120px;
          border-radius: 5px;
        }
      }
    }
  }
}
</style>
